import { type ApiRequest, type ApiResponseSingle, properCallApi } from '@/api/tenantClient';

export interface PaymentLinkResponse {
  paymentLink: string
}

export interface ConvertToInvoiceRequest {
  orderId: number
}

export function generateOutstandingPaymentLink(createTenantAdminRequest: () => ApiRequest) {
  const request = createTenantAdminRequest();
  return async (orderId: number): Promise<ApiResponseSingle<PaymentLinkResponse>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/admin/payments/generate_outstanding_payment_link';
    request.endpoint.query = { order_id: orderId };
    return await properCallApi<ApiResponseSingle<PaymentLinkResponse>>(request);
  };
}

export function convertToInvoice(createTenantAdminRequest: () => ApiRequest) {
  const request = createTenantAdminRequest();
  return async (params: ConvertToInvoiceRequest): Promise<ApiResponseSingle<void>> => {
    request.method = 'POST';
    request.endpoint.path = '/api/v1/admin/orders/convert_to_invoice';
    request.payload = params;
    return await properCallApi<ApiResponseSingle<void>>(request);
  };
}
